export const tipoPessoaOptions = [
  { label: 'Física', value: 'F' },
  { label: 'Jurídica', value: 'J' },
];
